/* KW – Sortierung der Kategorieseiten (08.10.2026)
   1) Ersetzt die Sortierliste durch: [Empfohlen] · Meistverkauft · Beste Bewertung ·
      Preis aufsteigend · Preis absteigend · Neuheiten.
      „Empfohlen“ nur, wenn die Kategorie eine eigene Standard-Reihenfolge hat.
   2) „Beste Bewertung“ (sort_by=rating) kennt Shopify nicht: Das Skript lädt alle Seiten
      der Kategorie (mit aktiven Filtern), sortiert nach Durchschnittsbewertung, dann nach
      Anzahl der Bewertungen; Artikel ohne Bewertung stehen am Ende (sonst Bestseller-Reihenfolge).
   Eingebunden über snippets/meta-tags.liquid, nur auf Kategorieseiten. */
(function () {
  var skript = document.currentScript;
  var STD = (skript && skript.getAttribute('data-kw-std')) || 'best-selling';
  var OPTIONEN = [
    ['best-selling', 'Meistverkauft'],
    ['rating', 'Beste Bewertung'],
    ['price-ascending', 'Preis aufsteigend'],
    ['price-descending', 'Preis absteigend'],
    ['created-descending', 'Neuheiten']
  ];
  var EIGENE = OPTIONEN.map(function (o) { return o[0]; });
  var laeuft = false;

  function aktuell() {
    return new URLSearchParams(location.search).get('sort_by') || STD;
  }

  function listeAnpassen() {
    var akt = aktuell();
    document.querySelectorAll('select[name="sort_by"]').forEach(function (sel) {
      if (sel.dataset.kwSort === akt) return;
      var liste = OPTIONEN.slice();
      if (EIGENE.indexOf(STD) === -1) liste.unshift([STD, 'Empfohlen']);
      sel.innerHTML = '';
      liste.forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o[0];
        opt.textContent = o[1];
        if (o[0] === akt) { opt.selected = true; opt.setAttribute('selected', 'selected'); }
        sel.appendChild(opt);
      });
      sel.dataset.kwSort = akt;
    });
  }

  function zahl(el, re) {
    if (!el) return 0;
    var m = el.textContent.replace(',', '.').match(re);
    return m ? parseFloat(m[1]) : 0;
  }

  function bewertungSortieren() {
    if (aktuell() !== 'rating') return;
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.dataset.id || laeuft) return;
    var schluessel = location.search;
    if (grid.dataset.kwSortiert === schluessel) return;
    laeuft = true;
    var behaelter = document.getElementById('ProductGridContainer') || grid.parentNode;
    var seiten = 1;
    behaelter.querySelectorAll('.pagination__list a, .pagination__list span').forEach(function (a) {
      var n = parseInt(a.textContent.trim(), 10);
      if (!isNaN(n) && n > seiten) seiten = n;
    });
    grid.style.opacity = '0.4';
    var abrufe = [];
    for (var s = 1; s <= seiten; s++) {
      var p = new URLSearchParams(location.search);
      p.set('page', s);
      p.set('section_id', grid.dataset.id);
      abrufe.push(fetch(location.pathname + '?' + p.toString()).then(function (r) { return r.text(); }));
    }
    Promise.all(abrufe).then(function (texte) {
      var eintraege = [];
      texte.forEach(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        d.querySelectorAll('#product-grid > li').forEach(function (li) {
          eintraege.push({
            li: li,
            note: zahl(li.querySelector('.rating-text'), /([0-9.]+)/),
            anzahl: zahl(li.querySelector('.rating-count'), /([0-9]+)/),
            pos: eintraege.length
          });
        });
      });
      if (!eintraege.length) return;
      eintraege.sort(function (a, b) {
        return (b.note - a.note) || (b.anzahl - a.anzahl) || (a.pos - b.pos);
      });
      var g = document.getElementById('product-grid');
      if (!g) return;
      g.innerHTML = '';
      eintraege.forEach(function (e) { g.appendChild(document.importNode(e.li, true)); });
      g.dataset.kwSortiert = schluessel;
      var pag = behaelter.querySelector('.pagination-wrapper');
      if (pag) pag.style.display = 'none';
      if (typeof window.initializeScrollAnimationTrigger === 'function') {
        try { window.initializeScrollAnimationTrigger(g); } catch (e) {}
      }
    }).catch(function () {}).then(function () {
      var g = document.getElementById('product-grid');
      if (g) g.style.opacity = '';
      laeuft = false;
    });
  }

  var takt = null;
  function alles() {
    clearTimeout(takt);
    takt = setTimeout(function () { listeAnpassen(); bewertungSortieren(); }, 30);
  }

  function start() {
    listeAnpassen();
    bewertungSortieren();
    new MutationObserver(alles).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('popstate', alles);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
